// src/pages/Contact.js
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';


const Edit = ({ edit, toggle_Edit, invoiceId, refreshData, AddcurrentPage }) => {
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const [formData, setFormData] = useState({

    id: '',
    banks: '',
    accountNumber: null,

  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  //*********************************** Fetch invoice data when the modal opens ********************************************************
  const token = authServices.getToken();
  useEffect(() => {

    const fetchInvoiceData = async () => {
      if (edit && invoiceId) {
        loader('enable');

        try {
          const response = await apiClient.get(`/api/admin/bank/${invoiceId}`, {

            headers: {
              'access_token': token,
            },

          });
          if (response.data.Status === "SUCCESS") {

            setFormData({
              id: invoiceId || '',
              banks: response.data.data.banks || null,
              accountNumber: response.data.data.accountNumber || null,
            });
          }
          else {
            console.log(response.data.message)
          }
        } catch (error) {
          console.error('catch Error :- ', error.response ? error.response.data.message : error);
        } finally {
          loader('disable');
        }
      }
    };

    fetchInvoiceData();
  }, [invoiceId, edit]);


  //******************************************* Handle save and update the data **************************************************
  const handleSave = async () => {
    loader('enable');

    try {
      const response = await apiClient.put(`/api/admin/bank/update`, formData, {

        headers: {
          'access_token': token,
        },

      });
      if (response.data.Status === "SUCCESS") {
        toast.success(response.data.message);
      }
      else {
        toast.error(response.data.message);
        console.log(response.data.message)
      }
    }
    catch (error) {
      toast.error(error.response.data.message);
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      toggle_Edit();
      loader('disable');
    }
  };

  return (
    <>
      {edit && (
        <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalScrollableTitle">
                  Edit Bank
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle_Edit} >
                  < RxCross2 />
                </button>
              </div>
              <div className="modal-body-custom">
                <form>
                  <div className="row ">
                    <div className="spacing w-50 d-inline-block" >
                      <label htmlFor="banks" className="label-custom">Bank Name</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="banks"
                        name="banks"
                        value={formData.banks}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block" >
                      <label htmlFor="accountNumber" className="label-custom">Account Number</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="accountNumber"
                        name="accountNumber"
                        value={formData.accountNumber}
                        onChange={handleChange}
                        onInput={(e) => {
                          // Allow digits and a single decimal point
                          e.target.value = e.target.value.replace(/[^0-9.]/g, ''); // Only allow digits and dots
                          // Prevent more than one decimal point
                          if ((e.target.value.match(/\./g) || []).length > 1) {
                            e.target.value = e.target.value.replace(/\.+$/, '');
                          }
                        }}
                      />
                    </div>
                  </div>

                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={toggle_Edit}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Edit;
